import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRedirectPlayerUserSuspended = (isUserSuspended, tracking) => {
const navigate = useNavigate();

  useEffect(
    () => {
      const isInPlayer = window.location.href?.includes('watch');
      if (!isInPlayer || !isUserSuspended || !tracking) return;
      tracking?.handleStop();
      navigate(-1);
    },
    [isUserSuspended],
  );
};
